module.exports = __webpack_public_path__ + "bcb927a742a8370b76642fd1a9a749c0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff
// module id = 33
// module chunks = 0